import React from "react";

function AttributionsGreek() {
  return (
    <>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="Generator" content="Microsoft Word 15 (filtered)" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:"Noto Sans Symbols";\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0cm;\n\tline-height:115%;\n\tfont-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\n.MsoChpDefault\n\t{font-size:11.0pt;}\n.MsoPapDefault\n\t{line-height:115%;}\n@page WordSection1\n\t{size:595.45pt 841.7pt;\n\tmargin:72.0pt 72.0pt 72.0pt 72.0pt;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0cm;}\nul\n\t{margin-bottom:0cm;}\n-->\n',
        }}
      />
      <div className="WordSection1">
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "24.0pt", lineHeight: "130%" }}
            >
              Attributions
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Τελευταία ενημέρωση στις 22 Μαρτίου 2025
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Αυτή η σελίδα παραθέτει πακέτα και άδειες χρήσης που
            χρησιμοποιούνται στο{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Join
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            . Λάβετε υπόψη σας ότι δεν απαιτούν όλα τα πακέτα που χρησιμοποιούμε
            αναφορά και μόνο μερικά από όλα τα πακέτα που χρησιμοποιούμε
            περιλαμβάνονται σε αυτή τη λίστα. Εκφράζουμε την ευγνωμοσύνη μας
            στους προγραμματιστές και τους οργανισμούς που διέθεσαν αυτά τα
            εργαλεία.{" "}
          </span>
        </p>
        <h2>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Ανάλυση των εξαρτήσεων λογισμικού:
          </span>
        </h2>
        <p className="MsoNormal">
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                Flutter
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                {" "}
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EL"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                (
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                Front
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EL"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                -
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                end
              </span>
            </u>
          </b>
          <b>
            <u>
              <span
                lang="EL"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                ):
              </span>
            </u>
          </b>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Apache-2.0:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            app_links,google_fonts,image_picker
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            BSD-2-Clause:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            fast_immutable_collections,filter_list,flutter_typeahead
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            BSD-3-Clause:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            cloud_firestore,collection,connectivity_plus,crypto,device_info_plus,firebase_analytics,firebase_app_installations,firebase_auth,firebase_core,firebase_crashlytics,firebase_database,firebase_messaging,flutter_animate,flutter_local_notifications,flutter_secure_storage,go_router,google_sign_in,http,http_parser,image_cropper,internet_connection_checker_plus,intl,logging,mime,path_provider,qr_flutter,share_plus,shared_preferences,url_launcher,video_player,visibility_detector,flutter_localizations,animations,keyboard_height_plugin
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            MIT:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            animate_gradient,another_transformer_page_view,audioplayers,cached_network_image,card_swiper,carousel_slider_plus,cupertino_icons,dart_jsonwebtoken,dropdown_button2,email_validator,emoji_picker_flutter,flutter_cache_manager,flutter_emoji,flutter_facebook_auth,flutter_feather_icons,flutter_hooks,flutter_keyboard_visibility,flutter_launcher_icons,flutter_native_splash,flutter_riverpod,flutter_slidable,flutter_staggered_animations,flutter_svg,font_awesome_flutter,geolocator,gradient_borders,grouped_list,hooks_riverpod,hugeicons,image,in_app_review,ionicons,lottie,material_design_icons_flutter,permission_handler,photo_view,pin_code_fields,reorderables,sign_in_with_apple,sticky_grouped_list,swipeable_page_route,synchronized,uuid,
          </span>
          <span lang="EN-GB" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            any_link_preview,flutter_dotenv
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Distributor License:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            mapbox_maps_flutter(Copyright © 2022 - 2023 Mapbox, Mapbox Maps
            Flutter SDK)
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                Python (Back-end):
              </span>
            </u>
          </b>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Apache-2.0:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            transformers, NSFW model, PyRequests, stomp
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            MIT:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            discordwebhook
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            lgpl-2.1:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            ffmpeg, MariaDB
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            BSD-3-Clause:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Pygit, Flask
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            PSF:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Python
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            HPND:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Python PIL (pillow)
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <b>
            <u>
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                Node.js (Back-end):
              </span>
            </u>
          </b>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Apache-2.0:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            firebase-admin,sharp,stompjs,@stomp/stompjs,fuse.js,webstomp-client
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            BSD-3-Clause:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            bcryptjs
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            LGPL-2.1:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            mariadb
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            MIT:
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            kysely,stompit,bcrypt,logrocket,cookie-parser,cors,debug,dotenv,express,express-validator,http-errors,jsonwebtoken,jwt-decode,moment,moment-timezone,morgan,multer,nodemon,typia,uuid,validator
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "2.85pt",
            marginRight: "0cm",
            marginBottom: "2.85pt",
            marginLeft: "0cm",
            lineHeight: "130%",
          }}
        >
          <b>
            <u>
              <span
                lang="EL"
                style={{ fontSize: "16.0pt", lineHeight: "130%" }}
              >
                Άδειες
              </span>
            </u>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "130%" }}
            >
              Apache License
            </span>
          </b>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "12.0pt", lineHeight: "130%" }}
            >
              <br />
            </span>
          </b>
          <b>
            <span style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Version:
            </span>
          </b>
          <span style={{ fontSize: "12.0pt", lineHeight: "130%" }}>&nbsp;</span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            2.0, January 2004
          </span>
          <span style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            <br />
            <b>Description:</b>
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            <br />
            Licensed under the Apache License, Version 2.0
            <br />
            <br />
            Apache License
            <br />
            Version 2.0, January 2004
            <br />
          </span>
          <span lang="el">
            <a href="http://www.apache.org/licenses/" target="_blank">
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                http://www.apache.org/licenses/
              </span>
            </a>
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            <br />
            <br />
            TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
            <br />
            <br />
            1. Definitions.
            <br />
            <br />
            "License" shall mean the terms and conditions for use, reproduction,
            <br />
            and distribution as defined by Sections 1 through 9 of this
            document.
            <br />
            <br />
            "Licensor" shall mean the copyright owner or entity authorized by
            <br />
            the copyright owner that is granting the License.
            <br />
            <br />
            "Legal Entity" shall mean the union of the acting entity and all
            <br />
            other entities that control, are controlled by, or are under common
            <br />
            control with that entity. For the purposes of this definition,
            <br />
            "control" means (i) the power, direct or indirect, to cause the
            <br />
            direction or management of such entity, whether by contract or
            <br />
            otherwise, or (ii) ownership of fifty percent (50%) or more of the
            <br />
            outstanding shares, or (iii) beneficial ownership of such entity.
            <br />
            <br />
            "You" (or "Your") shall mean an individual or Legal Entity
            <br />
            exercising permissions granted by this License.
            <br />
            <br />
            "Source" form shall mean the preferred form for making
            modifications,
            <br />
            including but not limited to software source code, documentation
            <br />
            source, and configuration files.
            <br />
            <br />
            "Object" form shall mean any form resulting from mechanical
            <br />
            transformation or translation of a Source form, including but
            <br />
            not limited to compiled object code, generated documentation,
            <br />
            and conversions to other media types.
            <br />
            <br />
            "Work" shall mean the work of authorship, whether in Source or
            <br />
            Object form, made available under the License, as indicated by a
            <br />
            copyright notice that is included in or attached to the work
            <br />
            (an example is provided in the Appendix below).
            <br />
            <br />
            "Derivative Works" shall mean any work, whether in Source or Object
            <br />
            form, that is based on (or derived from) the Work and for which the
            <br />
            editorial revisions, annotations, elaborations, or other
            modifications
            <br />
            represent, as a whole, an original work of authorship. For the
            purposes
            <br />
            of this License, Derivative Works shall not include works that
            remain
            <br />
            separable from, or merely link (or bind by name) to the interfaces
            of,
            <br />
            the Work and Derivative Works thereof.
            <br />
            <br />
            "Contribution" shall mean any work of authorship, including
            <br />
            the original version of the Work and any modifications or additions
            <br />
            to that Work or Derivative Works thereof, that is intentionally
            <br />
            submitted to Licensor for inclusion in the Work by the copyright
            owner
            <br />
            or by an individual or Legal Entity authorized to submit on behalf
            of
            <br />
            the copyright owner. For the purposes of this definition,
            "submitted"
            <br />
            means any form of electronic, verbal, or written communication sent
            <br />
            to the Licensor or its representatives, including but not limited to
            <br />
            communication on electronic mailing lists, source code control
            systems,
            <br />
            and issue tracking systems that are managed by, or on behalf of, the
            <br />
            Licensor for the purpose of discussing and improving the Work, but
            <br />
            excluding communication that is conspicuously marked or otherwise
            <br />
            designated in writing by the copyright owner as "Not a
            Contribution."
            <br />
            <br />
            "Contributor" shall mean Licensor and any individual or Legal Entity
            <br />
            on behalf of whom a Contribution has been received by Licensor and
            <br />
            subsequently incorporated within the Work.
            <br />
            <br />
            2. Grant of Copyright License. Subject to the terms and conditions
            of
            <br />
            this License, each Contributor hereby grants to You a perpetual,
            <br />
            worldwide, non-exclusive, no-charge, royalty-free, irrevocable
            <br />
            copyright license to reproduce, prepare Derivative Works of,
            <br />
            publicly display, publicly perform, sublicense, and distribute the
            <br />
            Work and such Derivative Works in Source or Object form.
            <br />
            <br />
            3. Grant of Patent License. Subject to the terms and conditions of
            <br />
            this License, each Contributor hereby grants to You a perpetual,
            <br />
            worldwide, non-exclusive, no-charge, royalty-free, irrevocable
            <br />
            (except as stated in this section) patent license to make, have
            made,
            <br />
            use, offer to sell, sell, import, and otherwise transfer the Work,
            <br />
            where such license applies only to those patent claims licensable
            <br />
            by such Contributor that are necessarily infringed by their
            <br />
            Contribution(s) alone or by combination of their Contribution(s)
            <br />
            with the Work to which such Contribution(s) was submitted. If You
            <br />
            institute patent litigation against any entity (including a<br />
            cross-claim or counterclaim in a lawsuit) alleging that the Work
            <br />
            or a Contribution incorporated within the Work constitutes direct
            <br />
            or contributory patent infringement, then any patent licenses
            <br />
            granted to You under this License for that Work shall terminate
            <br />
            as of the date such litigation is filed.
            <br />
            <br />
            4. Redistribution. You may reproduce and distribute copies of the
            <br />
            Work or Derivative Works thereof in any medium, with or without
            <br />
            modifications, and in Source or Object form, provided that You
            <br />
            meet the following conditions:
            <br />
            <br />
            (a) You must give any other recipients of the Work or
            <br />
            Derivative Works a copy of this License; and
            <br />
            <br />
            (b) You must cause any modified files to carry prominent notices
            <br />
            stating that You changed the files; and
            <br />
            <br />
            (c) You must retain, in the Source form of any Derivative Works
            <br />
            that You distribute, all copyright, patent, trademark, and
            <br />
            attribution notices from the Source form of the Work,
            <br />
            excluding those notices that do not pertain to any part of
            <br />
            the Derivative Works; and
            <br />
            <br />
            (d) If the Work includes a "NOTICE" text file as part of its
            <br />
            distribution, then any Derivative Works that You distribute must
            <br />
            include a readable copy of the attribution notices contained
            <br />
            within such NOTICE file, excluding those notices that do not
            <br />
            pertain to any part of the Derivative Works, in at least one
            <br />
            of the following places: within a NOTICE text file distributed
            <br />
            as part of the Derivative Works; within the Source form or
            <br />
            documentation, if provided along with the Derivative Works; or,
            <br />
            within a display generated by the Derivative Works, if and
            <br />
            wherever such third-party notices normally appear. The contents
            <br />
            of the NOTICE file are for informational purposes only and
            <br />
            do not modify the License. You may add Your own attribution
            <br />
            notices within Derivative Works that You distribute, alongside
            <br />
            or as an addendum to the NOTICE text from the Work, provided
            <br />
            that such additional attribution notices cannot be construed
            <br />
            as modifying the License.
            <br />
            <br />
            You may add Your own copyright statement to Your modifications and
            <br />
            may provide additional or different license terms and conditions
            <br />
            for use, reproduction, or distribution of Your modifications, or
            <br />
            for any such Derivative Works as a whole, provided Your use,
            <br />
            reproduction, and distribution of the Work otherwise complies with
            <br />
            the conditions stated in this License.
            <br />
            <br />
            5. Submission of Contributions. Unless You explicitly state
            otherwise,
            <br />
            any Contribution intentionally submitted for inclusion in the Work
            <br />
            by You to the Licensor shall be under the terms and conditions of
            <br />
            this License, without any additional terms or conditions.
            <br />
            Notwithstanding the above, nothing herein shall supersede or modify
            <br />
            the terms of any separate license agreement you may have executed
            <br />
            with Licensor regarding such Contributions.
            <br />
            <br />
            6. Trademarks. This License does not grant permission to use the
            trade
            <br />
            names, trademarks, service marks, or product names of the Licensor,
            <br />
            except as required for reasonable and customary use in describing
            the
            <br />
            origin of the Work and reproducing the content of the NOTICE file.
            <br />
            <br />
            7. Disclaimer of Warranty. Unless required by applicable law or
            <br />
            agreed to in writing, Licensor provides the Work (and each
            <br />
            Contributor provides its Contributions) on an "AS IS" BASIS,
            <br />
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
            <br />
            implied, including, without limitation, any warranties or conditions
            <br />
            of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A<br />
            PARTICULAR PURPOSE. You are solely responsible for determining the
            <br />
            appropriateness of using or redistributing the Work and assume any
            <br />
            risks associated with Your exercise of permissions under this
            License.
            <br />
            <br />
            8. Limitation of Liability. In no event and under no legal theory,
            <br />
            whether in tort (including negligence), contract, or otherwise,
            <br />
            unless required by applicable law (such as deliberate and grossly
            <br />
            negligent acts) or agreed to in writing, shall any Contributor be
            <br />
            liable to You for damages, including any direct, indirect, special,
            <br />
            incidental, or consequential damages of any character arising as a
            <br />
            result of this License or out of the use or inability to use the
            <br />
            Work (including but not limited to damages for loss of goodwill,
            <br />
            work stoppage, computer failure or malfunction, or any and all
            <br />
            other commercial damages or losses), even if such Contributor
            <br />
            has been advised of the possibility of such damages.
            <br />
            <br />
            9. Accepting Warranty or Additional Liability. While redistributing
            <br />
            the Work or Derivative Works thereof, You may choose to offer,
            <br />
            and charge a fee for, acceptance of support, warranty, indemnity,
            <br />
            or other liability obligations and/or rights consistent with this
            <br />
            License. However, in accepting such obligations, You may act only
            <br />
            on Your own behalf and on Your sole responsibility, not on behalf
            <br />
            of any other Contributor, and only if You agree to indemnify,
            <br />
            defend, and hold each Contributor harmless for any liability
            <br />
            incurred by, or claims asserted against, such Contributor by reason
            <br />
            of your accepting any such warranty or additional liability.
            <br />
            <br />
            END OF TERMS AND CONDITIONS
            <br />
            <br />
            APPENDIX: How to apply the Apache License to your work.
            <br />
            <br />
            To apply the Apache License to your work, attach the following
            <br />
            boilerplate notice, with the fields enclosed by brackets "[]"
            <br />
            replaced with your own identifying information. (Don't include
            <br />
            the brackets!) The text should be enclosed in the appropriate
            <br />
            comment syntax for the file format. We also recommend that a<br />
            file or class name and description of purpose be included on the
            <br />
            same "printed page" as the copyright notice for easier
            <br />
            identification within third-party archives.
            <br />
            <br />
            Copyright [yyyy] [name of copyright owner]
            <br />
            <br />
            Licensed under the Apache License, Version 2.0 (the "License");
            <br />
            you may not use this file except in compliance with the License.
            <br />
            You may obtain a copy of the License at
            <br />
            <br />
          </span>
          <span lang="el">
            <a
              href="http://www.apache.org/licenses/LICENSE-2.0"
              target="_blank"
            >
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", lineHeight: "130%" }}
              >
                http://www.apache.org/licenses/LICENSE-2.0
              </span>
            </a>
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            <br />
            <br />
            Unless required by applicable law or agreed to in writing, software
            <br />
            distributed under the License is distributed on an "AS IS" BASIS,
            <br />
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
            implied.
            <br />
            See the License for the specific language governing permissions and
            <br />
            limitations under the License.
            <br />
            <br />
            ## Some of TensorFlow's code is derived from Caffe, which is subject
            to the following copyright notice:
            <br />
            <br />
            COPYRIGHT
            <br />
            <br />
            All contributions by the University of California:
            <br />
            <br />
            Copyright (c) 2014, The Regents of the University of California
            (Regents)
            <br />
            All rights reserved.
            <br />
            <br />
            All other contributions:
            <br />
            <br />
            Copyright (c) 2014, the respective contributors
            <br />
            All rights reserved.
            <br />
            <br />
            Caffe uses a shared copyright model: each contributor holds
            copyright over
            <br />
            their contributions to Caffe. The project versioning records all
            such
            <br />
            contribution and copyright details. If a contributor wants to
            further mark
            <br />
            their specific copyright on a particular contribution, they should
            indicate
            <br />
            their copyright solely in the commit message of the change when it
            is
            <br />
            committed.
            <br />
            <br />
            LICENSE
            <br />
            <br />
            Redistribution and use in source and binary forms, with or without
            <br />
            modification, are permitted provided that the following conditions
            are met:
            <br />
            <br />
            1. Redistributions of source code must retain the above copyright
            notice, this
            <br />
            list of conditions and the following disclaimer.
            <br />
            <br />
            2. Redistributions in binary form must reproduce the above copyright
            notice,
            <br />
            this list of conditions and the following disclaimer in the
            documentation
            <br />
            and/or other materials provided with the distribution.
            <br />
            <br />
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
            "AS IS" AND
            <br />
            ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
            THE IMPLIED
            <br />
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE
            <br />
            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
            LIABLE FOR
            <br />
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES
            <br />
            (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
            SERVICES;
            <br />
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND
            <br />
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT
            <br />
            (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE
            USE OF THIS
            <br />
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            <br />
            <br />
            CONTRIBUTION AGREEMENT
            <br />
            <br />
            By contributing to the BVLC/caffe repository through pull-request,
            comment,
            <br />
            or otherwise, the contributor releases their content to the
            <br />
            license and copyright terms herein.
          </span>
        </p>
        <p
          className="MsoListParagraph"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "130%" }}
            >
              Caffe
              <br />
              Description:
            </span>
          </b>
          <span lang="EN-US" style={{ fontSize: "16.0pt", lineHeight: "130%" }}>
            <br />
            All contributions by the University of California:
            <br />
            Copyright (c) 2014, The Regents of the University of California
            (Regents)
            <br />
            All rights reserved.
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            <br />
            <br />
            All other contributions:
            <br />
            Copyright (c) 2014, the respective contributors
            <br />
            All rights reserved.
            <br />
            Caffe uses a shared copyright model: each contributor holds
            copyright over
            <br />
            their contributions to Caffe. The project versioning records all
            such
            <br />
            contribution and copyright details. If a contributor wants to
            further mark
            <br />
            their specific copyright on a particular contribution, they should
            indicate
            <br />
            their copyright solely in the commit message of the change when it
            is
            <br />
            committed.
            <br />
            <br />
            LICENSE
            <br />
            Redistribution and use in source and binary forms, with or without
            <br />
            modification, are permitted provided that the following conditions
            are met:
            <br />
            <br />
            1. Redistributions of source code must retain the above copyright
            notice, this
            <br />
            list of conditions and the following disclaimer.
            <br />
            <br />
            2. Redistributions in binary form must reproduce the above copyright
            notice,
            <br />
            this list of conditions and the following disclaimer in the
            documentation
            <br />
            and/or other materials provided with the distribution.
            <br />
            <br />
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
            "AS IS" AND
            <br />
            ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
            THE IMPLIED
            <br />
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE
            <br />
            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
            LIABLE FOR
            <br />
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES
            <br />
            (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
            SERVICES;
            <br />
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND
            <br />
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT
            <br />
            (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE
            USE OF THIS
            <br />
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            <br />
            <br />
            CONTRIBUTION AGREEMENT
            <br />
            <br />
            By contributing to the BVLC/caffe repository through pull-request,
            comment,
            <br />
            or otherwise, the contributor releases their content to the
            <br />
            license and copyright terms herein{" "}
          </span>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "5.6pt" }}>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "115%" }}
            >
              ΜΙΤ License
              <br />
              Version:&nbsp;2.0, January 2004
              <br />
              Description:
            </span>
          </b>
        </p>
        <p
          className="PreformattedText"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "16.0pt",
              lineHeight: "130%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Copyright (c) 2024 Join Social App
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "2.75pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "8.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "5.6pt" }}>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "115%" }}
            >
              GNU LESSER GENERAL PUBLIC LICENSE
              <br />
              Version:&nbsp;2.1, February 1999 <br />
              Description:
            </span>
          </b>
        </p>
        <p
          className="PreformattedText"
          style={{ marginBottom: "5.6pt", lineHeight: "normal" }}
        >
          <span
            lang="EN-US"
            style={{ fontSize: "16.0pt", fontFamily: '"Arial",sans-serif' }}
          >
            Copyright (C) 1991, 1999 Free Software Foundation, Inc.
          </span>
        </p>
        <p className="PreformattedText" style={{ lineHeight: "normal" }}>
          <span
            lang="EN-US"
            style={{ fontSize: "12.0pt", fontFamily: '"Arial",sans-serif' }}
          >
            &lt;
          </span>
          <span lang="EL">
            <a href="https://fsf.org/">
              <span
                lang="EN-US"
                style={{ fontSize: "12.0pt", fontFamily: '"Arial",sans-serif' }}
              >
                https://fsf.org/
              </span>
            </a>
          </span>
          <span
            lang="EN-US"
            style={{ fontSize: "12.0pt", fontFamily: '"Arial",sans-serif' }}
          >
            &gt;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Everyone is permitted to copy and distribute verbatim copies
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            of this license document, but changing it is not allowed.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            [This is the first released version of the Lesser GPL.&nbsp; It also
            counts
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;as the successor of the GNU Library Public License, version 2,
            hence
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;the version number 2.1.]
          </span>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "14.15pt" }}>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            The licenses for most software are designed to take away your
            freedom to share and change it. By contrast, the GNU General Public
            Licenses are intended to guarantee your freedom to share and change
            free software--to make sure the software is free for all its users.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            This license, the Lesser General Public License, applies to some
            specially designated software packages--typically libraries--of the
            Free Software Foundation and other authors who decide to use it. You
            can use it too, but we suggest you first think carefully about
            whether this license or the ordinary General Public License is the
            better strategy to use in any particular case, based on the
            explanations below.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            When we speak of free software, we are referring to freedom of use,
            not price. Our General Public Licenses are designed to make sure
            that you have the freedom to distribute copies of free software (and
            charge for this service if you wish); that you receive source code
            or can get it if you want it; that you can change the software and
            use pieces of it in new free programs; and that you are informed
            that you can do these things.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            To protect your rights, we need to make restrictions that forbid
            distributors to deny you these rights or to ask you to surrender
            these rights. These restrictions translate to certain
            responsibilities for you if you distribute copies of the library or
            if you modify it.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            For example, if you distribute copies of the library, whether gratis
            or for a fee, you must give the recipients all the rights that we
            gave you. You must make sure that they, too, receive or can get the
            source code. If you link other code with the library, you must
            provide complete object files to the recipients, so that they can
            relink them with the library after making changes to the library and
            recompiling it. And you must show them these terms so they know
            their rights.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            We protect your rights with a two-step method: (1) we copyright the
            library, and (2) we offer you this license, which gives you legal
            permission to copy, distribute and/or modify the library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            To protect each distributor, we want to make it very clear that
            there is no warranty for the free library. Also, if the library is
            modified by someone else and passed on, the recipients should know
            that what they have is not the original version, so that the
            original author's reputation will not be affected by problems that
            might be introduced by others.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Finally, software patents pose a constant threat to the existence of
            any free program. We wish to make sure that a company cannot
            effectively restrict the users of a free program by obtaining a
            restrictive license from a patent holder. Therefore, we insist that
            any patent license obtained for a version of the library must be
            consistent with the full freedom of use specified in this license.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Most GNU software, including some libraries, is covered by the
            ordinary GNU General Public License. This license, the GNU Lesser
            General Public License, applies to certain designated libraries, and
            is quite different from the ordinary General Public License. We use
            this license for certain libraries in order to permit linking those
            libraries into non-free programs.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            When a program is linked with a library, whether statically or using
            a shared library, the combination of the two is legally speaking a
            combined work, a derivative of the original library. The ordinary
            General Public License therefore permits such linking only if the
            entire combination fits its criteria of freedom. The Lesser General
            Public License permits more lax criteria for linking other code with
            the library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            We call this license the "Lesser" General Public License because it
            does Less to protect the user's freedom than the ordinary General
            Public License. It also provides other free software developers Less
            of an advantage over competing non-free programs. These
            disadvantages are the reason we use the ordinary General Public
            License for many libraries. However, the Lesser license provides
            advantages in certain special circumstances.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            For example, on rare occasions, there may be a special need to
            encourage the widest possible use of a certain library, so that it
            becomes a de-facto standard. To achieve this, non-free programs must
            be allowed to use the library. A more frequent case is that a free
            library does the same job as widely used non-free libraries. In this
            case, there is little to gain by limiting the free library to free
            software only, so we use the Lesser General Public License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            In other cases, permission to use a particular library in non-free
            programs enables a greater number of people to use a large body of
            free software. For example, permission to use the GNU C Library in
            non-free programs enables many more people to use the whole GNU
            operating system, as well as its variant, the GNU/Linux operating
            system.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Although the Lesser General Public License is Less protective of the
            users' freedom, it does ensure that the user of a program that is
            linked with the Library has the freedom and the wherewithal to run
            that program using a modified version of the Library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            The precise terms and conditions for copying, distribution and
            modification follow. Pay close attention to the difference between a
            "work based on the library" and a "work that uses the library". The
            former contains code derived from the library, whereas the latter
            must be combined with the library in order to run.{" "}
          </span>
        </p>
        <h4>
          <a name="SEC3" />
          <span lang="EN-US">
            TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
          </span>
        </h4>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              0.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            This License Agreement applies to any software library or other
            program which contains a notice placed by the copyright holder or
            other authorized party saying it may be distributed under the terms
            of this Lesser General Public License (also called "this License").
            Each licensee is addressed as "you".{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            A "library" means a collection of software functions and/or data
            prepared so as to be conveniently linked with application programs
            (which use some of those functions and data) to form executables.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            The "Library", below, refers to any such software library or work
            which has been distributed under these terms. A "work based on the
            Library" means either the Library or any derivative work under
            copyright law: that is to say, a work containing the Library or a
            portion of it, either verbatim or with modifications and/or
            translated straightforwardly into another language. (Hereinafter,
            translation is included without limitation in the term
            "modification".){" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            "Source code" for a work means the preferred form of the work for
            making modifications to it. For a library, complete source code
            means all the source code for all modules it contains, plus any
            associated interface definition files, plus the scripts used to
            control compilation and installation of the library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Activities other than copying, distribution and modification are not
            covered by this License; they are outside its scope. The act of
            running a program using the Library is not restricted, and output
            from such a program is covered only if its contents constitute a
            work based on the Library (independent of the use of the Library in
            a tool for writing it). Whether that is true depends on what the
            Library does and what the program that uses the Library does.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              1.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may copy and distribute verbatim copies of the Library's
            complete source code as you receive it, in any medium, provided that
            you conspicuously and appropriately publish on each copy an
            appropriate copyright notice and disclaimer of warranty; keep intact
            all the notices that refer to this License and to the absence of any
            warranty; and distribute a copy of this License along with the
            Library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            You may charge a fee for the physical act of transferring a copy,
            and you may at your option offer warranty protection in exchange for
            a fee.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              2.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may modify your copy or copies of the Library or any portion of
            it, thus forming a work based on the Library, and copy and
            distribute such modifications or work under the terms of Section 1
            above, provided that you also meet all of these conditions:{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              a)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            The modified work must itself be a software library.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              b)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You must cause the files modified to carry prominent notices stating
            that you changed the files and the date of any change.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              c)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You must cause the whole of the work to be licensed at no charge to
            all third parties under the terms of this License.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{ marginLeft: "35.45pt", textIndent: "-14.15pt" }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              d)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            If a facility in the modified Library refers to a function or a
            table of data to be supplied by an application program that uses the
            facility, other than as an argument passed when the facility is
            invoked, then you must make a good faith effort to ensure that, in
            the event an application does not supply such function or table, the
            facility still operates, and performs whatever part of its purpose
            remains meaningful.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            (For example, a function in a library to compute square roots has a
            purpose that is entirely well-defined independent of the
            application. Therefore, Subsection 2d requires that any
            application-supplied function or table used by this function must be
            optional: if the application does not supply it, the square root
            function must still compute square roots.)
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            These requirements apply to the modified work as a whole. If
            identifiable sections of that work are not derived from the Library,
            and can be reasonably considered independent and separate works in
            themselves, then this License, and its terms, do not apply to those
            sections when you distribute them as separate works. But when you
            distribute the same sections as part of a whole which is a work
            based on the Library, the distribution of the whole must be on the
            terms of this License, whose permissions for other licensees extend
            to the entire whole, and thus to each and every part regardless of
            who wrote it.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Thus, it is not the intent of this section to claim rights or
            contest your rights to work written entirely by you; rather, the
            intent is to exercise the right to control the distribution of
            derivative or collective works based on the Library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            In addition, mere aggregation of another work not based on the
            Library with the Library (or with a work based on the Library) on a
            volume of a storage or distribution medium does not bring the other
            work under the scope of this License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              3.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may opt to apply the terms of the ordinary GNU General Public
            License instead of this License to a given copy of the Library. To
            do this, you must alter all the notices that refer to this License,
            so that they refer to the ordinary GNU General Public License,
            version 2, instead of to this License. (If a newer version than
            version 2 of the ordinary GNU General Public License has appeared,
            then you can specify that version instead if you wish.) Do not make
            any other change in these notices.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Once this change is made in a given copy, it is irreversible for
            that copy, so the ordinary GNU General Public License applies to all
            subsequent copies and derivative works made from that copy.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            This option is useful when you wish to copy part of the code of the
            Library into a program that is not a library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              4.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may copy and distribute the Library (or a portion or derivative
            of it, under Section 2) in object code or executable form under the
            terms of Sections 1 and 2 above provided that you accompany it with
            the complete corresponding machine-readable source code, which must
            be distributed under the terms of Sections 1 and 2 above on a medium
            customarily used for software interchange.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            If distribution of object code is made by offering access to copy
            from a designated place, then offering equivalent access to copy the
            source code from the same place satisfies the requirement to
            distribute the source code, even though third parties are not
            compelled to copy the source along with the object code.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              5.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            A program that contains no derivative of any portion of the Library,
            but is designed to work with the Library by being compiled or linked
            with it, is called a "work that uses the Library". Such a work, in
            isolation, is not a derivative work of the Library, and therefore
            falls outside the scope of this License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            However, linking a "work that uses the Library" with the Library
            creates an executable that is a derivative of the Library (because
            it contains portions of the Library), rather than a "work that uses
            the library". The executable is therefore covered by this License.
            Section 6 states terms for distribution of such executables.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            When a "work that uses the Library" uses material from a header file
            that is part of the Library, the object code for the work may be a
            derivative work of the Library even though the source code is not.
            Whether this is true is especially significant if the work can be
            linked without the Library, or if the work is itself a library. The
            threshold for this to be true is not precisely defined by law.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            If such an object file uses only numerical parameters, data
            structure layouts and accessors, and small macros and small inline
            functions (ten lines or less in length), then the use of the object
            file is unrestricted, regardless of whether it is legally a
            derivative work. (Executables containing this object code plus
            portions of the Library will still fall under Section 6.){" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Otherwise, if the work is a derivative of the Library, you may
            distribute the object code for the work under the terms of Section
            6. Any executables containing that work also fall under Section 6,
            whether or not they are linked directly with the Library itself.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              6.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            As an exception to the Sections above, you may also combine or link
            a "work that uses the Library" with the Library to produce a work
            containing portions of the Library, and distribute that work under
            terms of your choice, provided that the terms permit modification of
            the work for the customer's own use and reverse engineering for
            debugging such modifications.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            You must give prominent notice with each copy of the work that the
            Library is used in it and that the Library and its use are covered
            by this License. You must supply a copy of this License. If the work
            during execution displays copyright notices, you must include the
            copyright notice for the Library among them, as well as a reference
            directing the user to the copy of this License.{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Also, you must do one of these things:{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              a)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Accompany the work with the complete corresponding machine-readable
            source code for the Library including whatever changes were used in
            the work (which must be distributed under Sections 1 and 2 above);
            and, if the work is an executable linked with the Library, with the
            complete machine-readable "work that uses the Library", as object
            code and/or source code, so that the user can modify the Library and
            then relink to produce a modified executable containing the modified
            Library. (It is understood that the user who changes the contents of
            definitions files in the Library will not necessarily be able to
            recompile the application to use the modified definitions.){" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              b)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Use a suitable shared library mechanism for linking with the
            Library. A suitable mechanism is one that (1) uses at run time a
            copy of the library already present on the user's computer system,
            rather than copying library functions into the executable, and (2)
            will operate properly with a modified version of the library, if the
            user installs one, as long as the modified version is
            interface-compatible with the version that the work was made with.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              c)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Accompany the work with a written offer, valid for at least three
            years, to give the same user the materials specified in Subsection
            6a, above, for a charge no more than the cost of performing this
            distribution.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              d)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            If distribution of the work is made by offering access to copy from
            a designated place, offer equivalent access to copy the above
            specified materials from the same place.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{ marginLeft: "35.45pt", textIndent: "-14.15pt" }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              e)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Verify that the user has already received a copy of these materials
            or that you have already sent this user a copy.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            For an executable, the required form of the "work that uses the
            Library" must include any data and utility programs needed for
            reproducing the executable from it. However, as a special exception,
            the materials to be distributed need not include anything that is
            normally distributed (in either source or binary form) with the
            major components (compiler, kernel, and so on) of the operating
            system on which the executable runs, unless that component itself
            accompanies the executable.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            It may happen that this requirement contradicts the license
            restrictions of other proprietary libraries that do not normally
            accompany the operating system. Such a contradiction means you
            cannot use both them and the Library together in an executable that
            you distribute.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              7.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may place library facilities that are a work based on the
            Library side-by-side in a single library together with other library
            facilities not covered by this License, and distribute such a
            combined library, provided that the separate distribution of the
            work based on the Library and of the other library facilities is
            otherwise permitted, and provided that you do these two things:{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{
            marginTop: "0cm",
            marginRight: "0cm",
            marginBottom: "0cm",
            marginLeft: "35.45pt",
            textIndent: "-14.15pt",
          }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              a)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Accompany the combined library with a copy of the same work based on
            the Library, uncombined with any other library facilities. This must
            be distributed under the terms of the Sections above.{" "}
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{ marginLeft: "35.45pt", textIndent: "-14.15pt" }}
        >
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: "Symbol",
            }}
          >
            ·
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              b)
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Give prominent notice with the combined library of the fact that
            part of it is a work based on the Library, and explaining where to
            find the accompanying uncombined form of the same work.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              8.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You may not copy, modify, sublicense, link with, or distribute the
            Library except as expressly provided under this License. Any attempt
            otherwise to copy, modify, sublicense, link with, or distribute the
            Library is void, and will automatically terminate your rights under
            this License. However, parties who have received copies, or rights,
            from you under this License will not have their licenses terminated
            so long as such parties remain in full compliance.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              9.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            You are not required to accept this License, since you have not
            signed it. However, nothing else grants you permission to modify or
            distribute the Library or its derivative works. These actions are
            prohibited by law if you do not accept this License. Therefore, by
            modifying or distributing the Library (or any work based on the
            Library), you indicate your acceptance of this License to do so, and
            all its terms and conditions for copying, distributing or modifying
            the Library or works based on it.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              10.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            Each time you redistribute the Library (or any work based on the
            Library), the recipient automatically receives a license from the
            original licensor to copy, distribute, link with or modify the
            Library subject to these terms and conditions. You may not impose
            any further restrictions on the recipients' exercise of the rights
            granted herein. You are not responsible for enforcing compliance by
            third parties with this License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              11.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            If, as a consequence of a court judgment or allegation of patent
            infringement or for any other reason (not limited to patent issues),
            conditions are imposed on you (whether by court order, agreement or
            otherwise) that contradict the conditions of this License, they do
            not excuse you from the conditions of this License. If you cannot
            distribute so as to satisfy simultaneously your obligations under
            this License and any other pertinent obligations, then as a
            consequence you may not distribute the Library at all. For example,
            if a patent license would not permit royalty-free redistribution of
            the Library by all those who receive copies directly or indirectly
            through you, then the only way you could satisfy both it and this
            License would be to refrain entirely from distribution of the
            Library.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            If any portion of this section is held invalid or unenforceable
            under any particular circumstance, the balance of the section is
            intended to apply, and the section as a whole is intended to apply
            in other circumstances.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            It is not the purpose of this section to induce you to infringe any
            patents or other property right claims or to contest validity of any
            such claims; this section has the sole purpose of protecting the
            integrity of the free software distribution system which is
            implemented by public license practices. Many people have made
            generous contributions to the wide range of software distributed
            through that system in reliance on consistent application of that
            system; it is up to the author/donor to decide if he or she is
            willing to distribute software through any other system and a
            licensee cannot impose that choice.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            This section is intended to make thoroughly clear what is believed
            to be a consequence of the rest of this License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              12.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            If the distribution and/or use of the Library is restricted in
            certain countries either by patents or by copyrighted interfaces,
            the original copyright holder who places the Library under this
            License may add an explicit geographical distribution limitation
            excluding those countries, so that distribution is permitted only in
            or among countries not thus excluded. In such case, this License
            incorporates the limitation as if written in the body of this
            License.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              13.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            The Free Software Foundation may publish revised and/or new versions
            of the Lesser General Public License from time to time. Such new
            versions will be similar in spirit to the present version, but may
            differ in detail to address new problems or concerns.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Each version is given a distinguishing version number. If the
            Library specifies a version number of this License which applies to
            it and "any later version", you have the option of following the
            terms and conditions either of that version or of any later version
            published by the Free Software Foundation. If the Library does not
            specify a license version number, you may choose any version ever
            published by the Free Software Foundation.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              14.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            If you wish to incorporate parts of the Library into other free
            programs whose distribution conditions are incompatible with these,
            write to the author to ask for permission. For software which is
            copyrighted by the Free Software Foundation, write to the Free
            Software Foundation; we sometimes make exceptions for this. Our
            decision will be guided by the two goals of preserving the free
            status of all derivatives of our free software and of promoting the
            sharing and reuse of software generally.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              NO WARRANTY
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              15.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            BECAUSE THE LIBRARY IS LICENSED FREE OF CHARGE, THERE IS NO WARRANTY
            FOR THE LIBRARY, TO THE EXTENT PERMITTED BY APPLICABLE LAW. EXCEPT
            WHEN OTHERWISE STATED IN WRITING THE COPYRIGHT HOLDERS AND/OR OTHER
            PARTIES PROVIDE THE LIBRARY "AS IS" WITHOUT WARRANTY OF ANY KIND,
            EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
            PURPOSE. THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE
            LIBRARY IS WITH YOU. SHOULD THE LIBRARY PROVE DEFECTIVE, YOU ASSUME
            THE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION.{" "}
          </span>
        </p>
        <p className="MsoBodyText">
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "12.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              16.
            </span>
          </strong>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            {" "}
            IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED TO IN
            WRITING WILL ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO MAY MODIFY
            AND/OR REDISTRIBUTE THE LIBRARY AS PERMITTED ABOVE, BE LIABLE TO YOU
            FOR DAMAGES, INCLUDING ANY GENERAL, SPECIAL, INCIDENTAL OR
            CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE
            LIBRARY (INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR DATA BEING
            RENDERED INACCURATE OR LOSSES SUSTAINED BY YOU OR THIRD PARTIES OR A
            FAILURE OF THE LIBRARY TO OPERATE WITH ANY OTHER SOFTWARE), EVEN IF
            SUCH HOLDER OR OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Copyright (C){" "}
          </span>
          <span className="Variable">
            <span lang="EN-US" style={{ fontFamily: '"Arial",sans-serif' }}>
              2024
            </span>
          </span>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
          <span className="Variable">
            <span lang="EN-US" style={{ fontFamily: '"Arial",sans-serif' }}>
              Join Social App
            </span>
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            This library is free software; you can redistribute it and/or
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            modify it under the terms of the GNU Lesser General Public
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            License as published by the Free Software Foundation; either
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            version 2.1 of the License, or (at your option) any later version.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            This library is distributed in the hope that it will be useful,
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            but WITHOUT ANY WARRANTY; without even the implied warranty of
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.&nbsp; See the
            GNU
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Lesser General Public License for more details.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            You should have received a copy of the GNU Lesser General Public
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            License along with this library; if not, see
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &lt;
          </span>
          <span lang="EL">
            <a href="https://www.gnu.org/licenses/">
              <span
                lang="EN-US"
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "115%",
                  fontFamily: '"Arial",sans-serif',
                }}
              >
                https://www.gnu.org/licenses/
              </span>
            </a>
          </span>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &gt;.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            5.{" "}
          </span>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "16.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              BSD-2-Clause License
            </span>
          </strong>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "0cm" }}>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "16.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              Description:
            </span>
          </strong>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "0cm" }}>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "16.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "14.15pt" }}>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "16.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              Copyright 2025 Join Social App
            </span>
          </strong>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met:
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            1. Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            2. Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
            “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
            LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
            FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
            COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
            BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
            ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE.
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "14.15pt" }}>
          <strong>
            <span
              lang="EN-US"
              style={{
                fontSize: "16.0pt",
                lineHeight: "115%",
                fontFamily: '"Arial",sans-serif',
              }}
            >
              BSD-3-Clause License
            </span>
          </strong>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "115%" }}
            >
              {" "}
              <br />
              Description:
            </span>
          </b>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "14.15pt" }}>
          <span lang="EN-US" style={{ fontSize: "16.0pt", lineHeight: "115%" }}>
            Copyright 2025 Join Social App
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met:
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            1. Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            2. Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            3. Neither the name of the copyright holder nor the names of its
            contributors may be used to endorse or promote products derived from
            this software without specific prior written permission.
          </span>
        </p>
        <p className="MsoBodyText">
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "115%" }}>
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
            “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
            LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
            FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
            COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
            BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
            ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE.
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span lang="EN-US" style={{ fontFamily: '"Arial",sans-serif' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoBodyText" style={{ marginBottom: "14.15pt" }}>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "16.0pt", lineHeight: "115%" }}
            >
              7. PSF LICENSE AGREEMENT FOR PYTHON 3.12
            </span>
          </b>
          <span lang="EN-US" style={{ fontSize: "16.0pt", lineHeight: "115%" }}>
            <br />
            <b>Version:</b>&nbsp;2.1, February 1999 <br />
            <b>Description:</b>
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            1. This LICENSE AGREEMENT is between the Python Software Foundation
            ("PSF"), and
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; the Individual or Organization ("Licensee") accessing
            and otherwise using Python
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; 3.12.6 software in source or binary form and its
            associated documentation.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            2. Subject to the terms and conditions of this License Agreement,
            PSF hereby
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; grants Licensee a nonexclusive, royalty-free,
            world-wide license to reproduce,
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; analyze, test, perform and/or display publicly, prepare
            derivative works,
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; distribute, and otherwise use Python 3.12.6 alone or in
            any derivative
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; version, provided, however, that PSF's License
            Agreement and PSF's notice of
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; copyright, i.e., "Copyright © 2001-2023 Python Software
            Foundation; All Rights
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; Reserved" are retained in Python 3.12.6 alone or in any
            derivative version
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; prepared by Licensee.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            3. In the event Licensee prepares a derivative work that is based on
            or
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; incorporates Python 3.12.6 or any part thereof, and
            wants to make the
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; derivative work available to others as provided herein,
            then Licensee hereby
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; agrees to include in any such work a brief summary of
            the changes made to Python
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; 3.12.6.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            4. PSF is making Python 3.12.6 available to Licensee on an "AS IS"
            basis.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; PSF MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR
            IMPLIED.&nbsp; BY WAY OF
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; EXAMPLE, BUT NOT LIMITATION, PSF MAKES NO AND DISCLAIMS
            ANY REPRESENTATION OR
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY
            PARTICULAR PURPOSE OR THAT THE
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; USE OF PYTHON 3.12.6 WILL NOT INFRINGE ANY THIRD PARTY
            RIGHTS.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            5. PSF SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF PYTHON
            3.12.6
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES
            OR LOSS AS A RESULT OF
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; MODIFYING, DISTRIBUTING, OR OTHERWISE USING PYTHON
            3.12.6, OR ANY DERIVATIVE
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; THEREOF, EVEN IF ADVISED OF THE POSSIBILITY THEREOF.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            6. This License Agreement will automatically terminate upon a
            material breach of
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; its terms and conditions.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            7. Nothing in this License Agreement shall be deemed to create any
            relationship
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; of agency, partnership, or joint venture between PSF
            and Licensee.&nbsp; This License
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; Agreement does not grant permission to use PSF
            trademarks or trade name in a
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; trademark sense to endorse or promote products or
            services of Licensee, or any
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; third party.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            8. By copying, installing or otherwise using Python 3.12.6, Licensee
            agrees
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp; to be bound by the terms and conditions of this License
            Agreement.
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span lang="EN-US" style={{ fontFamily: '"Arial",sans-serif' }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoBodyText"
          style={{ marginBottom: "14.15pt", lineHeight: "normal" }}
        >
          <b>
            <span lang="EN-US" style={{ fontSize: "16.0pt" }}>
              The Python Imaging Library License
            </span>
          </b>
          <span lang="EN-US" style={{ fontSize: "16.0pt" }}>
            <br />
            <b>Version:</b>&nbsp;2.1, February 1999 <br />
            <b>Description:</b>
          </span>
        </p>
        <p
          className="PreformattedText"
          style={{ marginBottom: "14.15pt", lineHeight: "normal" }}
        >
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "12.0pt", fontFamily: '"Arial",sans-serif' }}
            >
              The Python Imaging Library (PIL) is
            </span>
          </b>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp;&nbsp; Copyright © 1997-2011 by Secret Labs AB
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp;&nbsp; Copyright © 1995-2011 by Fredrik Lundh and
            contributors
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Pillow is the friendly PIL fork. It is
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;&nbsp;&nbsp; Copyright © 2010-2024 by Jeffrey A. Clark and
            contributors
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Like PIL, Pillow is licensed under the open source HPND License:
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            By obtaining, using, and/or copying this software and/or its
            associated
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            documentation, you agree that you have read, understood, and will
            comply
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            with the following terms and conditions:
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            Permission to use, copy, modify and distribute this software and its
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            documentation for any purpose and without fee is hereby granted,
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            provided that the above copyright notice appears in all copies, and
            that
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            both that copyright notice and this permission notice appear in
            supporting
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            documentation, and that the name of Secret Labs AB or the author not
            be
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            used in advertising or publicity pertaining to distribution of the
            software
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            without specific, written prior permission.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            &nbsp;
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            SECRET LABS AB AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD
            TO THIS
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
            FITNESS.
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            IN NO EVENT SHALL SECRET LABS AB OR THE AUTHOR BE LIABLE FOR ANY
            SPECIAL,
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER
            RESULTING FROM
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
            NEGLIGENCE
          </span>
        </p>
        <p className="PreformattedText">
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE
            USE OR
          </span>
        </p>
        <p className="PreformattedText" style={{ marginBottom: "14.15pt" }}>
          <span
            lang="EN-US"
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Arial",sans-serif',
            }}
          >
            PERFORMANCE OF THIS SOFTWARE.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "18.0pt", lineHeight: "130%" }}
            >
              &nbsp;
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <b>
            <span lang="EL" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              Πώς να επικοινωνήσετε μαζί μας
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εάν έχετε οποιαδήποτε ερώτηση, παρακαλούμε χρησιμοποιείστε αυτή την
          </span>
          <span lang="EL"> </span>
          <span lang="el">
            <a href="https://join-socialapp.com/contact">
              <span lang="EL">Φόρμα Επικοινωνίας</span>
            </a>
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            .
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginBottom: "14.0pt", lineHeight: "130%" }}
        >
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EL">&nbsp;</span>
        </p>
        <p className="MsoNormal">
          <span lang="EL">&nbsp;</span>
        </p>
        <p className="MsoNormal">
          <span lang="el">&nbsp;</span>
        </p>
      </div>
    </>
  );
}

export default AttributionsGreek;
